/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */

/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */

// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript'
// @ts-ignore
// prettier-ignore
import type { RequestConfig, RequestFunctionRestArgs } from 'yapi-to-typescript'
// @ts-ignore
import request from '../../request';

type UserRequestRestArgs = RequestFunctionRestArgs<typeof request>;

// Request: 目前 React Hooks 功能有用到
export type Request<
  TRequestData,
  TRequestConfig extends RequestConfig,
  TRequestResult
> = (TRequestConfig['requestDataOptional'] extends true
  ? (requestData?: TRequestData, ...args: RequestFunctionRestArgs<typeof request>) => TRequestResult
  : (requestData: TRequestData, ...args: RequestFunctionRestArgs<typeof request>) => TRequestResult) & {
  requestConfig: TRequestConfig;
};

const mockUrl_0_0_0_0 = 'http://10.50.16.213:40001/mock/283' as any;
const devUrl_0_0_0_0 = '' as any;
const prodUrl_0_0_0_0 = 'http://127.0.0.1' as any;
const dataKey_0_0_0_0 = 'retdata' as any;

/**
 * @分类 [mock规则管理↗](http://10.50.16.213:40001/project/283/interface/api/cat_2005)
 * @请求头 `GET /api/data-rule/{id}/view`
 */
export interface IdViewGetRequest {
  /**
   * 开始时间，毫秒
   */
  from: string;
  /**
   * 持续时间，单位小时
   */
  duration: string;
  /**
   * Y轴倍率默认值
   */
  yMagnificationValue?: string;
  /**
   * 累积量起始值默认值
   */
  cumulativeStartValue?: string;
  /**
   * 时区偏移值。例如东八区是-8
   */
  zoneOffset?: string;
  /**
   * id
   */
  id: string;
}

/**
 * @分类 [mock规则管理↗](http://10.50.16.213:40001/project/283/interface/api/cat_2005)
 * @请求头 `GET /api/data-rule/{id}/view`
 */
export type IdViewGetResponse = {
  /**
   * 时间戳，毫秒
   */
  time?: number;
  /**
   * 值
   */
  value?: number;
}[];

/**
 * @分类 [mock规则管理↗](http://10.50.16.213:40001/project/283/interface/api/cat_2005)
 * @请求头 `GET /api/data-rule/{id}/view`
 */
type ApiDataRuleIdViewGetRequestConfig = Readonly<
  RequestConfig<
    'http://10.50.16.213:40001/mock/283',
    '',
    'http://127.0.0.1',
    '/api/data-rule/{id}/view',
    'retdata',
    'id',
    'from' | 'duration' | 'yMagnificationValue' | 'cumulativeStartValue' | 'zoneOffset',
    false
  >
>;

/**
 * @分类 [mock规则管理↗](http://10.50.16.213:40001/project/283/interface/api/cat_2005)
 * @请求头 `GET /api/data-rule/{id}/view`
 */
const apiDataRuleIdViewGetRequestConfig: ApiDataRuleIdViewGetRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/api/data-rule/{id}/view',
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: ['id'],
  queryNames: ['from', 'duration', 'yMagnificationValue', 'cumulativeStartValue', 'zoneOffset'],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'apiDataRuleIdViewGet',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * @分类 [mock规则管理↗](http://10.50.16.213:40001/project/283/interface/api/cat_2005)
 * @请求头 `GET /api/data-rule/{id}/view`
 */
export const apiDataRuleIdViewGet = /*#__PURE__*/ (requestData: IdViewGetRequest, ...args: UserRequestRestArgs) => {
  return request<IdViewGetResponse>(prepare(apiDataRuleIdViewGetRequestConfig, requestData), ...args);
};

apiDataRuleIdViewGet.requestConfig = apiDataRuleIdViewGetRequestConfig;

/* prettier-ignore-end */
